var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGraphql(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.67 3.521l4.523 2.612a1.965 1.965 0 013.125.367 1.965 1.965 0 01-1.242 2.888v5.226a1.955 1.955 0 011.236 2.886 1.964 1.964 0 01-3.164.325l-4.496 2.596A1.963 1.963 0 0111.79 23a1.959 1.959 0 01-1.881-2.515l-4.523-2.612a1.963 1.963 0 11-1.883-3.26V9.388A1.964 1.964 0 012.261 6.5a1.964 1.964 0 013.123-.37L9.91 3.519A1.959 1.959 0 0111.79 1a1.959 1.959 0 011.88 2.521zm-.472.805l4.535 2.618a1.958 1.958 0 001.41 2.44v5.231l-.075.02-5.922-10.257.052-.052v0zm-2.763.053L4.513 14.637a1.877 1.877 0 00-.077-.021V9.383A1.95 1.95 0 005.908 7.72c.032-.261.011-.526-.062-.779l4.534-2.617.055.055v0zm1.903.465l5.92 10.255a1.95 1.95 0 00-.551.957H5.873a1.966 1.966 0 00-.551-.955l5.922-10.256a1.967 1.967 0 001.094 0zm.902 14.874l4.505-2.6a1.981 1.981 0 01-.036-.13H5.87l-.02.077 4.526 2.613a1.955 1.955 0 011.413-.6 1.954 1.954 0 011.45.64z",
    strokeWidth: 0.4
  })));
}

export default SvgGraphql;